<ng-template let-modal #addNewType>
  <div class="d-flex w-100 flex-column" style="padding: 2rem;">
    <div class="row">
      <div class="form-group col-12">
        <label>Name </label>
        <input type="text" placeholder="New Type Name" [(ngModel)]="newSubCategoryTypeName" class="form-control" />
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <div class="form-group col-12">
        <label class="mr-1">Type: </label>
        <span class="mr-2"> <input type="radio" value="1" [(ngModel)]="newSubCategoryType" /> 1</span>
        <span> <input type="radio" value="2" [(ngModel)]="newSubCategoryType" /> 2</span>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <button class="btn btn-success ml-2" (click)="createNewType()">
          <i class="fa fa-save"></i>
          Save
        </button>

      </div>
    </div>
  </div>
</ng-template>

<ng-template let-modal #changeTypeGrouingName>
  <div class="d-flex w-100 flex-column" style="padding: 2rem;">
    <div class="row">
      <div class="form-group col-12">
        <label>New Name </label>
        <input type="text" [placeholder]="'Custom name for type grouping ' + currentlyChangingNameOfTyeGrouping"
          [(ngModel)]="currentlyChangingNameOfTypeGroupingName" class="form-control" />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <button class="btn btn-success ml-2" (click)="saveCustomTypeGroupingName()">
          <i class="fa fa-save"></i>
          Save
        </button>
      </div>
    </div>
  </div>

</ng-template>

<ul class="nav nav-tabs mt-3">
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'sub-category' }" (click)="selectMenu('sub-category')">Assign
      Sub Category</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'assign-tag' }" (click)="selectMenu('assign-tag')">Assign
      Tag</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{ active: selMenu == 'FAQ' }" (click)="selectMenu('FAQ')">Subcategories/FAQ/Types</a>
  </li>
</ul>

<section class="mt-2" *ngIf="selMenu == 'FAQ'">
  <table class="table table-hover white_box shadow" style="margin-top: 10px">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Subcategory Name</th>
        <th scope="col">Type 1</th>
        <th scope="col">Type 2</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of allCategoryListWithSubCategory; let i = index">
        <tr *ngIf="!cates.has(item.id)">
          <td scope="row">{{ item.id }}</td>
          <td>{{ item?.name | titlecase }}</td>
          <td>
            <div class="d-flex" style="flex-wrap: wrap; font-size: .6rem;">
              <ng-container *ngFor="let type of item.subcategoryTypes">
                <button class="btn btn-sm btn-outline-primary m-1" *ngIf="type.type == 1">
                  <span class="mr-1">{{type.name}}</span>
                  <i class="fa fa-x" (click)="removeType(type)"></i>
                </button>
              </ng-container>
              <button class="btn btn-sm btn-outline-secondary m-1"
                (click)="openChangeTypeGroupingNamePopup(item.id, 1)">
                (Custom Name: {{typeCustomNamesMapping[item.id + 'x' + 1] ? typeCustomNamesMapping[item.id + 'x' + 1] :
                "Categories"}})
              </button>

            </div>
          </td>
          <td>
            <div class="d-flex" style="flex-wrap: wrap; font-size: .6rem;">
              <ng-container *ngFor="let type of item.subcategoryTypes">
                <button class="btn btn-sm btn-outline-primary m-1" *ngIf="type.type == 2">
                  <span class="mr-1">{{type.name}}</span>
                  <i class="fa fa-x" (click)="removeType(type)"></i>
                </button>
              </ng-container>
              <button class="btn btn-sm btn-outline-secondary m-1"
                (click)="openChangeTypeGroupingNamePopup(item.id, 2)">
                (Custom Name: {{typeCustomNamesMapping[item.id + 'x' + 2] ? typeCustomNamesMapping[item.id + 'x' + 2] :
                "Services"}})
              </button>
            </div>
          </td>
          <td>
            <div class="flex flex-column">
              <button class="btn btn-info mb-2" (click)="addCategory(addEditCategory, item)">
                <i class="fa fa-pencil" aria-hidden="true"></i>
                Edit Category
              </button>
              <button class="btn btn-outline-primary ml-2" (click)="showAddNewTypeModal(item.id)">
                <i class="fa fa-pencil" aria-hidden="true"></i>
                Add New Type
              </button>
            </div>

          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</section>

<section class="mt-2" *ngIf="selMenu == 'sub-category'">
  <span><button class="btn btn-secondary my-2 float-right" (click)="addCategory(addEditCategory)"><i
        class="fa fa-plus-circle" aria-hidden="true"></i> Add Category</button></span>
  <table class="table table-hover white_box shadow" style="margin-top: 10px">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Category Name</th>
        <th scope="col">Sub Category Name</th>
        <th scope="col">Image</th>
        <th scope="col">Banner Image</th>
        <th scope="col">Status</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of allCategoryList; let i = index">
        <th scope="row">{{ i + 1 }}</th>
        <td>{{ item?.name | titlecase }}</td>

        <td style="max-width: 20rem">
          <div class="row">
            <ng-container *ngFor="let s of item?.subCategory">
              <span (click)="toggleRoleOnSubCategory(s)" class="sub-cate p-2 m-2 col-3">{{ s?.categoryName }} <span
                  *ngIf="s?.isCategoryARole">({{ s?.roleName ?? "unnamed role" }})</span> <i class="fa fa-minus-circle"
                  aria-hidden="true" (click)="removeRelationship(s.id)"></i></span>
            </ng-container>
          </div>
        </td>
        <td><img loading="lazy" *ngIf="item.image" style="height: 5rem" [src]="imgUrl + item.image" /></td>
        <td><img loading="lazy" *ngIf="item.bannerImage" style="height: 5rem" [src]="imgUrl + item.bannerImage" /></td>
        <td>
          <span>{{ item?.status }}</span>
        </td>
        <td class="text-right">
          <section class="d-flex justify-content-center">
            <button class="btn btn-info" (click)="addCategory(addEditCategory, item)">
              <i class="fa fa-pencil" aria-hidden="true"></i>
              Edit Category
            </button>

            <button class="btn btn-secondary ml-2" (click)="openAssign(AssignOption, item)"><i class="fa fa-users"
                aria-hidden="true"></i> Assign Sub Category</button>

            <button class="btn btn-danger ml-2" (click)="deleteCategory(item?.id)"><i class="fa fa-trash"
                aria-hidden="true"></i> Delete Category</button>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<section class="mt-2" *ngIf="selMenu == 'assign-tag'">
  <span><button class="btn btn-secondary my-2 float-right" (click)="addCategory(addEditCategory)"><i
        class="fa fa-plus-circle" aria-hidden="true"></i> Add Category</button></span>
  <table class="table table-hover white_box shadow" style="margin-top: 10px">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Category Name</th>
        <th scope="col">Tags</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of allCategoryListWithSubCategory; let i = index">
        <th scope="row">{{ i + 1 }}</th>
        <td>{{ item?.name | titlecase }}</td>

        <td style="max-width: 20rem">
          <div class="row">
            <ng-container *ngFor="let s of item?.tag">
              <span class="sub-cate p-2 m-2 col-3">{{ s?.interest?.interest_name }} <i class="fa fa-minus-circle"
                  aria-hidden="true" (click)="removeInterest(s.id)"></i></span>
            </ng-container>
          </div>
        </td>

        <td class="text-right">
          <section class="d-flex justify-content-center">
            <button class="btn btn-secondary ml-2" (click)="openAssignInterest(AssignInterest, item)"><i
                class="fa fa-users" aria-hidden="true"></i> Assign Tag To Category</button>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<ng-template #AssignInterest let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <section>
      <div><b>Tags : </b></div>
      <div class="my-4 row d-flex justify-content-center">
        <ng-container *ngFor="let c of assignInterestList">
          <span class="sub-cate p-2 m-2"> <input type="checkbox" [(ngModel)]="c.checked" /> {{ c?.interest_name
            }}</span>
        </ng-container>
      </div>
    </section>

    <duv class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="assignInterestRelationshipSubmit()">Assign</button>
    </duv>
  </div>
</ng-template>

<ng-template #AssignOption let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <section>
      <div><b>Sub Category : </b></div>
      <div class="my-4 row d-flex justify-content-center">
        <ng-container *ngFor="let c of assignCategoryList">
          <span class="sub-cate p-2 m-2"> <input type="checkbox" [(ngModel)]="c.checked" /> {{ c.name }}</span>
        </ng-container>
      </div>
    </section>

    <duv class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="assignRelationshipSubmit()">Assign</button>
    </duv>
  </div>
</ng-template>

<ng-template #addEditCategory let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add/Edit Category</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <!-- Event Image -->
    <img loading="lazy" *ngIf="imageBase64" class="map-search-listing-img mt-2 product-char-image w-100"
      [src]="imageBase64" alt="" />
    <img loading="lazy" *ngIf="selectedCategory?.image" class="map-search-listing-img mt-2 product-char-image w-100"
      [src]="imgUrl + selectedCategory?.image" />

    <button class="com_btn px-1 month-list-add-more mt-3" (click)="upload.click()"><i class="fas fa-plus"></i> Upload
      Event Image</button>
    <input type="file" #upload (change)="saveProductCharSelectedImage($event)" class="suggestion-modal-pic-input d-none"
      accept="image/*" />
    <!-- End Event Image -->

    <!-- Banner Image -->
    <img loading="lazy" *ngIf="imageBase64Banner" class="map-search-listing-img mt-2 product-char-image w-100"
      [src]="imageBase64Banner" alt="" />
    <img loading="lazy" *ngIf="selectedCategory?.bannerImage"
      class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + selectedCategory?.bannerImage" />

    <button class="com_btn px-1 month-list-add-more mt-3" (click)="uploadBanner.click()"><i class="fas fa-plus"></i>
      Upload Banner Image</button>
    <input type="file" #uploadBanner (change)="saveProductCharSelectedImage($event, true)"
      class="suggestion-modal-pic-input d-none" accept="image/*" />
    <!-- End Banner Image -->

    <!-- Promo Banner Image -->
    <img loading="lazy" *ngIf="encodedPromoFile" class="map-search-listing-img mt-2 product-char-image w-100"
      [src]="encodedPromoFile" alt="" />
    <img loading="lazy" *ngIf="selectedCategory?.promoBannerImage"
      class="map-search-listing-img mt-2 product-char-image w-100"
      [src]="imgUrl + selectedCategory?.promoBannerImage" />

    <button class="com_btn px-1 month-list-add-more mt-3" (click)="uploadPromoImage.click()"><i class="fas fa-plus"></i>
      Upload Promo Image</button>
    <input type="file" #uploadPromoImage style="visibility: hidden" id="upload-promo-image"
      (change)="promoBannerChange($event)" class="suggestion-modal-pic-input d-none" accept="image/*" />

    <!-- End Promo Banner Image -->

    <div class="row">
      <div class="form-group col-12">
        <label for="RedirectURL">Redirect URL </label>
        <input type="text" placeholder="Redirect URL" [(ngModel)]="promoRedirectURL" class="form-control" />
      </div>
    </div>

    <ul class="nav nav-tabs mt-3">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'main' }" (click)="formMenu = 'main'">Main</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'meta' }" (click)="formMenu = 'meta'">Meta</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'faq' }" (click)="formMenu = 'faq'">FAQ</a>
      </li>
    </ul>

    <ng-container *ngIf="formMenu == 'main'">
      <div class="row">
        <div class="form-group col-12">
          <label for="exampleInputEmail1">Category Name </label>
          <input type="text" [(ngModel)]="categoryName" class="form-control" placeholder="Enter Category Name" />
        </div>
      </div>

     
      <div class="row">
        <div class="form-group col-12">
          <label for="bottomText">Bottom Text</label>
          <textarea id='bottomText' [(ngModel)]="bottomText" cols="30" rows="10" class="form-control"
            placeholder="Enter Bottom Text(HTML)"></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formMenu == 'meta'">
      <div class="row">
        <div class="form-group col-12">
          <label for="exampleInputEmail1">Meta Config</label>
          <textarea [(ngModel)]="categoryMeta" cols="30" rows="10" class="form-control"
            placeholder="Enter Meta Config"></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formMenu == 'meta'">
      <div class="row">
        <div class="form-group col-12">
          <label for="schemaCode">Schema Code </label>
          <textarea [(ngModel)]="codeSchema" cols="30" rows="10" class="form-control"
            placeholder="Enter Schema Code"></textarea>
        </div>
      </div>
    </ng-container>
 


    <ng-container *ngIf="formMenu == 'faq'">

      <!------------------------------------------------------------------------------------------>
      <div class="row">
        <div class="form-group col-12">
          <label for="question">Question One </label>
          <textarea [(ngModel)]="questionOne" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label for="ans1">Answer One</label>
          <textarea [(ngModel)]="answerOne" placeholder="Answer One" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <label for="question">Question Two </label>
          <textarea [(ngModel)]="questionTwo" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label for="ans1">Answer Two</label>
          <textarea [(ngModel)]="answerTwo" placeholder="Answer Two" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <label for="question">Question Three </label>
          <textarea [(ngModel)]="questionThree" placeholder="Question" cols="30" rows="1"
            class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label for="ans1">Answer Three</label>
          <textarea [(ngModel)]="anserThree" placeholder="Answer Three" cols="30" rows="5"
            class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <label for="question">Question Four </label>
          <textarea [(ngModel)]="questionFour" placeholder="Question" cols="30" rows="1"
            class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label for="ans1">Answer Four</label>
          <textarea [(ngModel)]="anserFour" placeholder="Answer Four" cols="30" rows="5"
            class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <label for="question">Question Five </label>
          <textarea [(ngModel)]="questionFive" placeholder="Question" cols="30" rows="1"
            class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <label for="ans1">Answer Five</label>
          <textarea [(ngModel)]="anserFive" placeholder="Answer Five" cols="30" rows="5"
            class="form-control"></textarea>
        </div>
      </div>
    </ng-container>

    <duv class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="AddEditCategorySubmit()">Save</button>
    </duv>
  </div>
</ng-template>

<ng-template let-modal #roleNameModal>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div class="p-3">
      <div class="form-group mb-3">
        <label for="roleName" class="form-label fw-bold">Role Name</label>
        <input type="text" id="roleName" class="form-control" placeholder="Enter role name"
          [(ngModel)]="currentRoleName" />
      </div>

      <div class="d-flex justify-content-end gap-2">
        <button class="my-button-3 px-4" (click)="saveCurrentRole(); modalService.dismissAll()"><i
            class="bi bi-check-circle me-1"></i> Save</button>
        <button class="ml-3 px-4 btn btn-outline"
          (click)="modalService.dismissAll(); toastr.info('Role editing cancelled')"><i class="bi bi-x-circle me-1"></i>
          Cancel</button>
      </div>
    </div>
  </div>
</ng-template>